<template>
  <div class="componentRoot">
    <ButtonRowVue>
      <template v-slot:leftSide>
        <v-col :cols="searchBarCols" class="pr-2">
          <SearchBarVue :labelArray="['basics.name']" @search="updateSearchQueue" />
        </v-col>
      </template>
      <v-col cols="auto" v-if="$checkRouterPermission('POST')">
        <v-btn @click="showEditBill($event)" class="primaryButton squareButton" flat><v-icon
            size="x-large">mdi-plus</v-icon></v-btn>
      </v-col>
    </ButtonRowVue>

    <TableVue :numPages="numPages" @switchPage="switchPage" id="unbilledTable" :page="currPage" :total="totalCount"
      :resetPage="resetPage">
      <thead>
        <tr>
          <th class="text-left" style="width: 150px">
            <b style="font-size: medium">{{ $t("basics.date") }}</b>
          </th>
          <th class="text-left">
            <b style="font-size: medium">{{ $t("basics.info") }}</b>
          </th>
          <th style="width: 80px"></th>
        </tr>
      </thead>
      <tbody v-for="ts in timeSlots" @click="showEditBill($event, ts)"
          :key="ts.id">
        <tr class="removeBorderBottom">
          <td style="width: 150px !important">
            {{ ts.display_date }}
          </td>
          <td>
            <b>{{ ts.product?.name }}</b>
          </td>
          <td>
          </td>
        </tr>
        <tr v-for="(p, pIndex) in ts.patients" :class="{removeBorderBottom: pIndex < ts.patients.length - 1}" class="removeTdHeight">
          <td style="width: 150px !important">
          </td>
          <td colspan="100">
              {{ p.user.full_name }}
          </td>
        </tr>
      </tbody>
      <tbody v-if="!timeSlots || timeSlots.length == 0">
        <tr>
          <td colspan="10">
            <p>
              <i>{{ $t("messages.noItems") }}</i>
            </p>
          </td>
        </tr>
      </tbody>
    </TableVue>


    <BillEditVue :refreshDisplay="editBillDrawer" :billData="activeBill"
      :readonly="!($checkRouterPermission('POST') || $checkRouterPermission('PATCH'))" @close="closeEditBill"
      />

    <LoadingScreenVue :loading="loading" />
  </div>
</template>

<script>
import BillEditVue from "../../../components/accounting/BillEdit.vue";

export default {
  name: "billList",
  
  data() {
    return {
      timeSlots: undefined,

      numPages: undefined,
      currPage: 1,
      pageSize: 10,
      totalCount: undefined,
      resetPage: 0,

      sortBy: "start_date",
      sortDirection: true,

      activeBill: undefined,
      editBillDrawer: 0,

      loading: false,

      searchQueue: "",
      filterQuery: "",
    };
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    searchBarCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 9;
        case "sm":
          return 9;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
  },

  components: {
    BillEditVue,
  },

  methods: {
    updateSearchQueue(value) {
      this.resetPage++;
      this.currPage = 1;
      this.searchQueue = value;

      this.fetchData();
    },
    getReadableDate(dateString) {
      if (!dateString) {
        return ""
      }
      return this.$moment(dateString).format("DD.MM.YYYY");
    },
    getReadableDateTime(dateString) {
      return this.$moment(dateString).format("DD.MM.YYYY HH:mm");
    },
    setLoading(value) {
      this.loading = value;
    },
    switchPage(data) {
      this.currPage = data;

      this.fetchData();
    },
    switchSortBy(val) {
      if (this.sortBy != val) {
        this.sortBy = val;
        this.sortDirection = true;
      } else {
        this.sortDirection = !this.sortDirection;
      }

      this.currPage = 1;

      this.fetchData();
    },
    showEditBill(event, bill = undefined) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.activeBill = bill;

      this.editBillDrawer++;
    },
    closeEditBill(data) {
      this.editBillDrawer = 0;
      if (data) {
        this.fetchData();
      }
    },
    fetchData() {
      this.setLoading(true);

      let searchParams =
        "?page=" +
        this.currPage +
        "&order=" +
        this.sortBy +
        "&direction=" +
        (this.sortDirection ? "up" : "down");

      if (this.searchQueue) {
        searchParams += "&query=" + this.searchQueue;
      }

      searchParams += "&unbilled=1"

      this.axios
        .get(this.axios.defaults.baseURL + "calendar/timeslots/" + searchParams)
        .then((resp) => {
          this.timeSlots = resp.data.results;
          this.totalCount = resp.data.count;

          if (resp.data.results.length == 0) {
            this.numPages = 0;
          } else if (this.currPage == 1) {
            this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
          }

          this.setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          this.setLoading(false);
        });
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>
